import { useEffect, useState } from "react";
import { auth } from "@/utils/firebase";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { LogOut } from "lucide-react";
import Logo from "@/assets/logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { sidebarList } from "@/hooks/useSidebar";
import apiClient from "@/services";
import { useIsMobile } from "@/components/hooks/use-mobile";
import getAllRequestsCount from "@/scripts/getAllRequestsCount";

function AppSidebar({ role }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState("");
  const [activePage, setActivePage] = useState("");

  const getData = async () => {
    try {
      const request = await apiClient.post("/getUnreadRequests", { role });
      if (request.data > 0) {
        setUnread(request.data);
      }
    } catch (error) {
      console.log("Error fetching data", error);
    }
  };

  const getAdminData = async () => {
    try {
      const count = await getAllRequestsCount();
      if (count > 0) {
        setUnread(count);
      }
    } catch (error) {
      console.log("Error fetching data", error);
    }
  };

  useEffect(() => {
    setItems(sidebarList[role] ?? []);

    // Sidebar notifications
    if (role === "seller_agent" || role === "buyer_agent") {
      getData();
    }

    // Sidebar notifications
    if (role === "admin") {
      getAdminData();
    }
  }, [role]);

  useEffect(() => {
    // Track active page
    setActivePage(location.pathname);
  }, [location]);

  const logout = async () => {
    localStorage.removeItem("manage_product_filters");
    await auth.signOut();
    navigate("/login");
  };

  return (
    <Sidebar>
      <SidebarContent style={styles.navbar}>
        <SidebarGroup>
          {isMobile && <SidebarTrigger />}

          <img src={Logo} alt="JP Associates" style={styles.logo} />

          <SidebarGroupContent>
            <SidebarMenu>
              {items.length > 0 &&
                items.map((item) => (
                  <SidebarMenuItem
                    key={item.title}
                    className={
                      activePage === item.url ? "bg-[#14BE73] rounded-md" : ""
                    }
                  >
                    <SidebarMenuButton asChild className="hover:bg-[#14BE73]">
                      <a href={item.url}>
                        <item.icon color="white" />

                        <span className="text-white">
                          {item.title}
                          {item.title === "Manage Requests" && (
                            <span className="ml-2">{unread}</span>
                          )}
                        </span>
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}

              <SidebarMenuItem>
                <SidebarMenuButton asChild className="hover:bg-[#14BE73]">
                  <div onClick={logout} className="cursor-pointer">
                    <LogOut color="white" />
                    <span className="text-white">Logout</span>
                  </div>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}

export default AppSidebar;

const styles = {
  navbar: {
    padding: 20,
    backgroundColor: "#07020D",
  },
  logo: {
    height: 100,
    marginBottom: 20,
    objectFit: "contain",
  },
};
